import { ArrowUpRight, CodeXml, Database, NotebookText } from "lucide-react";
import * as Routes from "routes";
import { StandardPageLayout } from "components/layouts/standard-page-layout";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardIcon,
  CardTitle,
} from "components/ui/card";

const documentation = [
  {
    title: "Data Documentation",
    description: "Explore Geoscape datasets, formats, and data product guidance.",
    href: Routes.geoscapeDocumentation,
    icon: Database,
    color: "text-chart-5",
  },
  {
    title: "Pre-release Reports",
    description: "Review upcoming changes and updates before they are released.",
    href: Routes.docsPreRelease,
    icon: NotebookText,
    color: "text-chart-2",
  },
  {
    title: "API Documentation",
    description: "Learn how to build with Geoscape APIs, guides, and references.",
    href: Routes.docsApi,
    icon: CodeXml,
    color: "text-chart-3",
  },
];

export const DocsPage = () => {
  return (
    <StandardPageLayout
      maxWidth="6xl"
      pageTitle={{
        icon: NotebookText,
        title: "Geoscape Documentation",
        description: "Find API references, data product guidance, and the latest pre-release updates.",
      }}
    >
      <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3">
        {documentation.map(({ title, description, href, icon: Icon, color }) => (
          <a key={title} href={href} target="_blank" rel="noopener noreferrer" className="group block no-underline">
            <Card className="group relative h-full cursor-pointer bg-card hover:bg-muted">
              <CardHeader>
                <CardIcon variant="default" className={`${color} self-center`}>
                  <Icon className="size-6" aria-hidden="true" />
                </CardIcon>
                <CardTitle>{title}</CardTitle>
              </CardHeader>
              <CardContent>
                <CardDescription>{description}</CardDescription>
                <ArrowUpRight className="absolute bottom-4 right-4 size-4 text-muted-foreground" aria-hidden="true" />
              </CardContent>
            </Card>
          </a>
        ))}
      </div>
    </StandardPageLayout>
  );
};
